import React from 'react';
import { Hero } from './components/Hero';
import { BenefitsStrip } from './components/BenefitsStrip';
import { SocialProofBar } from './components/SocialProofBar';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { ProblemSection } from './components/ProblemSection';
import { TestimonialHighlight } from './components/TestimonialHighlight';
import { ProductIntro } from './components/ProductIntro';
import { InsideCarousel } from './components/InsideCarousel';
import { TomosSection } from './components/TomosSection';
import { TransformationSection } from './components/TransformationSection';
import { BonosSection } from './components/BonosSection';
import { ForWhoSection } from './components/ForWhoSection';
import { ValueSection } from './components/ValueSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingCards } from './components/PricingCards';
import { ComparisonTable } from './components/ComparisonTable';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { useMetaPixel } from './hooks/useMetaPixel';
const META_PIXEL_ID = '2314996429237093';
export function App() {
  useMetaPixel();
  return <div className="min-h-full w-full bg-mp-black font-body" data-id="element-0" data-mp="2zmo3z3zwcd00">
      <noscript data-id="element-1" data-mp="33m5c656pjo8v">
        <img height={1} width={1} style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="33nq4do5juv3k" />
      </noscript>
      <main data-id="element-3" data-mp="3dm5ylzzvikha">
        <Hero data-id="element-4" data-mp="3dirw8rr7mb9u" />
        <BenefitsStrip data-id="element-5" data-mp="nvj53kddcmru" />
        <SocialProofBar data-id="element-6" data-mp="nw2e2bl1k0tq" />
        <ProblemSection data-id="element-7" data-mp="nur8q7by6l0i" />
        <TestimonialHighlight data-id="element-8" data-mp="nxn6nvnsp9oy" />
        <ProductIntro data-id="element-9" data-mp="sudmqizlo5ad" />
        <InsideCarousel data-id="element-10" data-mp="stkmm0v5ce17" />
        <TomosSection data-id="element-11" data-mp="st2hsfuf4rho" />
        <TransformationSection data-id="element-12" data-mp="swgk5o3310p4" />
        <BonosSection data-id="element-13" data-mp="35ynugqx9fzv" />
        <ForWhoSection data-id="element-14" data-mp="356ttacz3qbp" />
        <ValueSection data-id="element-15" data-mp="34nd1wz277z9" />
        <TestimonialsSection data-id="element-16" data-mp="3uct4hmy40t22" />
        <PricingCards data-id="element-17" data-mp="3udkmfuysas9v" />
        <ComparisonTable data-id="element-18" data-mp="3ubzvsgflbtha" />
        <GuaranteeSection data-id="element-19" data-mp="3uevqzx020421" />
        <FAQSection data-id="element-20" data-mp="d4e57s05daw6" />
        <FinalCTA data-id="element-21" data-mp="d4xmd6hz3v95" />
      </main>
      <Footer data-id="element-22" data-mp="d3wch5cp1et0" />
      <StickyMobileCTA data-id="element-23" data-mp="d2l6cyvrzuyq" />
      <PurchaseNotifications data-id="element-24" data-mp="85ujnspgu14c" />
    </div>;
}